import { RESET_TUTORIALS, SET_TUTORIALS_COMPLETED } from 'phoenix2/state/tutorial/actions';

export const FTQ_TUTORIAL_KEY = 'ftqTutorial';

export interface IFTQTutorialState {
    // Whether the student has completed the tutorial.
    completed: boolean;
}

const INITIAL_STATE: IFTQTutorialState = {
    completed: false,
};

export function FTQTutorialReducer(state = INITIAL_STATE, action: any): IFTQTutorialState {
    switch (action.type) {
        case RESET_TUTORIALS:
            return INITIAL_STATE;
        case SET_TUTORIALS_COMPLETED:
            if (action.tutorialIds.includes(FTQ_TUTORIAL_KEY)) {
                return {
                    completed: true,
                };
            }
            break;
    }
    return state;
}
